import { UsageFeatureProps } from '@employee-experience/common';
import { IUserProfile } from '../../models/IUserProfile';

export enum UserActionTypes {
  REQUEST_USERPROFILE = 'REQUEST_USERPROFILE',
  RECEIVE_USERPROFILE = 'RECEIVE_USERPROFILE',
  REQUEST_USERPROFILE_FAILED = 'REQUEST_USERPROFILE_FAILED',
}

export interface IRequestUserProfileAction {
  type: UserActionTypes.REQUEST_USERPROFILE;
  feature: UsageFeatureProps;
}

export interface IReceiveUserProfileAction {
  type: UserActionTypes.RECEIVE_USERPROFILE;
  userProfile: IUserProfile;
}

export interface IRequestUserProfileFailedAction {
  type: UserActionTypes.REQUEST_USERPROFILE_FAILED;
  errorMessage: string;
}

export type UserProfileActions =
  | IRequestUserProfileAction
  | IReceiveUserProfileAction
  | IRequestUserProfileFailedAction;
